/* eslint-disable camelcase */
import React, { Component } from "react";
import { connect } from "dva";
import router from "umi/router";
import {
  Button,
  Form,
  Tabs,
  Spin,
  Icon,
  Upload,
  message,
  InputNumber,
  Modal,
  Popconfirm,
} from "antd";
import WxEditor from "@/components/WxEditor";
import FormCreate from "../../../../../components/FormCreate/index";
import Container from "../../../../../components/Container";
import { url as api } from "../../services/service-utils";
import { GetQueryString, getAppCode } from "../../utils/utils";
import { convertData, getDefaultData } from "../../utils/convertData";
import { getPathHeader } from "../../../../../utils/utils";
import SelectTagModal from "./SelectTag/index";
import styles from "./index.less";

const { TabPane } = Tabs;
const { confirm } = Modal;

const { Item } = Form;
const { FormTitle, FormCascader, FileUpload } = FormCreate;

let wwei_editor = null;
@Form.create()
@connect(({ user }) => ({
  currentUser: user.currentUser
}))
class CreateVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinning: false,
      activeKey: "1",
      groupData: [],
      channelList: [],
      currentIndex: 0,

      uploadFileVOList: GetQueryString("id")
        ? []
        : [
            {
              lxVideoName: "",
              lxVideoId: "",
              title: "",
              lxVideoSize: "",
              coverPicFileId: "",
              newsId: null,
              completePercent: 100,
              content: ""
            }
          ],
      data: {
        defaultDataChannelId: [],
        content: ""
      }
    };
    this.id = GetQueryString("id") || "";
    this.from = GetQueryString("from") || "";
  }

  componentDidMount() {
    this.initData();
  }

  initData = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "edit/fetchLabelWithGroup",
      params: { appCode: getAppCode() }
    }).then(res => {
      this.setState(
        {
          groupData: res
        },
        () => {
          this.fetchChannelList();
        }
      );
    });
  };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: "edit/fetchChannelList",
      params: { appCode: getAppCode(), iseditnews: 1 }
    })
      .then(res => {
        this.setState({ channelList: convertData(res || []), spinning: false });
        if (this.id) {
          this.fetchNewsById(res);
        }
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchNewsById = channelList => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: "ceateVideo/fetchNewsById",
      params: { appCode: getAppCode(), id: this.id }
    })
      .then(res => {
        const arr = [];
        res.labelList.forEach(item => {
          arr.push({
            labelName: item.label,
            labelId: item.id
          });
        });
        const { groupData } = this.state;
        const groupDataArr = JSON.parse(JSON.stringify(groupData));

        groupDataArr.forEach(item => {
          item.list.forEach(tag => {
            res.labelList.forEach(checkedValue => {
              if (checkedValue.id === tag.labelId) {
                tag.checked = true;
              }
            });
          });
        });
        this.setState({
          groupData: groupDataArr,
          data: {
            channelId: getDefaultData(channelList, res.channelId)
          },
          uploadFileVOList: [
            {
              lxVideoName: res.files[0].filename,
              lxVideoId: res.newsInfoExtend && res.newsInfoExtend.lxVideoId || "",
              title: res.title,
              lxVideoSize: res.files[0].filesize,
              coverPicFileId: res.coverPicFileId,
              coverPicFileUrl: res.coverPicFileUrl,
              newsId: res.files[0].newsid,
              completePercent: res.newsInfoExtend && res.newsInfoExtend.completePercent || 100,
              labelList: arr,
              content: res.content
            }
          ],
          spinning: false
        });
        this.setCurrentItem(0);
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  // 0:保存  1:提交
  save = type => {
    const { uploadFileVOList, data } = this.state;
    const { defaultDataChannelId } = data;
    const { form } = this.props;
    const { getFieldsValue, validateFieldsAndScroll } = form;
    const values = getFieldsValue();
    const channelId = values.channelId || data.channelId;
    validateFieldsAndScroll(err => {
      if (!err) {
        if (this.formComplete(uploadFileVOList, channelId)) {
          return;
        }
        const params = {
          channelId: channelId ? channelId[channelId.length - 1] : defaultDataChannelId,
          newsType: "2",
          appCode: getAppCode(),
          uploadFileVOList,
          isSubmit: type
        };
        this.fetchSaveOrUpdateMaterialNews(params, type);
      }else{
        message.error("表单未填写完成，请检查！");
      }
    });
  };

  // 必填判断
  formComplete = (uploadFileVOList, channelId) => {
    let flag = false;
    let titleSize = false;
    uploadFileVOList.forEach(item => {
      if (
        (!this.id && !item.lxVideoId && !item.groupId) ||
        !item.coverPicFileId ||
        !item.completePercent ||
        !item.title
      ) {
        flag = true;
      }
      if (item.title && item.title.length > 100) {
        titleSize = true;
      }
    });
    if (titleSize) {
      message.error("素材标题请勿超过100个字符");
    }
    if (flag || !channelId) {
      message.error("表单未填写完成，请检查！");
    }
    return titleSize || flag || !channelId;
  };

  fetchSaveOrUpdateMaterialNews = (params, type) => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: "ceateVideo/fetchSaveOrUpdateMaterialNews",
      params
    })
      .then(() => {
        this.setState({ spinning: false }, () => {
          message.success(type === 1 ? "提交成功" : "保存成功");
          router.goBack();
        });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  fetchSubmit = id => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: "articleSubmissions/fetchSubmit",
      params: { ids: id, appCode: getAppCode() }
    })
      .then(() => {
        this.setState({ spinning: false });
        message.success("提交成功");
        router.goBack();
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  nextStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) + 1}` });
  };

  preStep = () => {
    const { activeKey } = this.state;
    this.setState({ activeKey: `${Number(activeKey) - 1}` });
  };

  handleSaveLabelOk = (data, index) => {
    const { checkedValue, groupData } = data;
    const { uploadFileVOList } = this.state;
    const arr = JSON.parse(JSON.stringify(uploadFileVOList));
    arr[index].labelList = checkedValue;
    this.setState({ uploadFileVOList: arr, groupData });
  };

  // 删除素材确认弹窗
  deleteVideo = index => {
    const { uploadFileVOList } = this.state;
    const arr = JSON.parse(JSON.stringify(uploadFileVOList));
    arr.splice(index, 1);
    this.setState({ uploadFileVOList: arr, currentIndex: 0 });
    const that = this;
    setTimeout(()=>{
      that.setCurrentItem(0);
    },0)
  };

  changeTab = activeKey => {
    this.setState({ activeKey });
  };

  onChange = (value, index, key) => {
    const { uploadFileVOList } = this.state;
    const arr = JSON.parse(JSON.stringify(uploadFileVOList));
    const ele = arr[index];
    ele[key] = value;
    arr[index] = ele;
    this.setState({ uploadFileVOList: arr });
  };

  // 新增一个素材项
  addVideo = () => {
    const { uploadFileVOList = [] } = this.state;
    if (uploadFileVOList.length >= 8) {
      message.error("最多上传8个素材");
      return;
    }
    const obj = {
      lxVideoName: "",
      lxVideoId: "",
      title: "",
      lxVideoSize: "",
      coverPicFileId: "",
      newsId: null,
      completePercent: 100
    };
    const arr = JSON.parse(JSON.stringify(uploadFileVOList));
    arr.push(obj);
    this.setState({ uploadFileVOList: arr });
    const that = this;
    setTimeout(()=>{
      that.setCurrentItem(arr.length-1);
    },0)
  };

  // 删除素材文件
  delVideo = () => {
    const { uploadFileVOList, currentIndex } = this.state;
    const arr = JSON.parse(JSON.stringify(uploadFileVOList));
    arr[currentIndex].lxVideoName = "";
    arr[currentIndex].lxVideoId = "";
    arr[currentIndex].lxVideoSize = "";
    this.setState({ uploadFileVOList: JSON.parse(JSON.stringify(arr)) });
  }

  setCurrentItem = index => {
    this.setState({ currentIndex: index }, () => {
      const { uploadFileVOList } = this.state;
      const { content="" } = uploadFileVOList[index] || {};
      if (uploadFileVOList[index] && content) {
        wwei_editor = window.UE.getEditor("wwei_editor");
        wwei_editor.ready(function() {
          wwei_editor.setContent(uploadFileVOList[index].content);
        });
      }
    });
  };

  renderTabTitle = (activeKey, title, index) => {
    return (
      <span>
        <i
          className={
            activeKey === index
              ? "common-icon-style active-style"
              : "common-icon-style icon-style"
          }
        >
          {index}
        </i>
        {title}
      </span>
    );
  };

  renderFooter = () => {
    const { activeKey, spinning } = this.state;
    let footerParams = {};

    if (activeKey === "1") {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button loading={spinning} onClick={() => this.save(0)}>
              保存
            </Button>
            <Button type="primary" onClick={this.nextStep}>
              下一步
            </Button>
          </>
        )
      };
    } else {
      footerParams = {
        states: !0,
        demFooter: (
          <>
            <Button onClick={this.preStep}>上一步</Button>
            <Button loading={spinning} onClick={() => this.save(0)}>
              保存
            </Button>
            {this.from === "workflow" || this.from === "matter" ? null : (
              <Button
                type="primary"
                loading={spinning}
                onClick={() => this.save(1)}
              >
                提交
              </Button>
            )}
          </>
        )
      };
    }
    return footerParams;
  };

  // 左边列表renderItem
  renderCommon = (record, index) => {
    const { currentIndex,uploadFileVOList } = this.state;
    return (
      <div
        key={index}
        className={`common-item ${
          currentIndex === index ? "common-item-active" : ""
        }`}
      >
        <div className="list-item-title" onClick={() => this.setCurrentItem(index)}>
          <div>{record.title || "标题"}</div>
          {(record.coverPicFileUrl && (
            <img src={record.coverPicFileUrl} alt="" />
          )) || <span className="default-img" />}
        </div>
        {/* 删除按钮 */}
        {uploadFileVOList.length>1 && currentIndex === index && (
          <Popconfirm
            placement="bottom"
            title='是否确定删除此篇内容？'
            onConfirm={() => {
              this.deleteVideo(index)
            }}
            okText="确定"
            cancelText="取消"
          >
            <div className="delete-icon">
              <img
                src="https://s.xiaoyuanhao.com/file/2f3fd4fd-c88c-440e-b6ed-0cf9b5952909.svg"
                alt=""
              />
            </div>
          </Popconfirm>
        )}
      </div>
    );
  };

  // render新建素材
  renderAdd = () => {
    return (
      <div className="add-box" onClick={this.addVideo}>
        + 新建素材
      </div>
    );
  };

  // render素材表单
  renderVideoItem = () => {
    const { currentIndex, uploadFileVOList } = this.state;
    const currentItem = uploadFileVOList[currentIndex] || {};
    const {
      lxVideoName,
      lxVideoId,
      title,
      lxVideoSize,
      coverPicFileUrl,
      labelList = [],
      completePercent,
      groupId
    } = currentItem;
    const { groupData = [] } = this.state;
    const { form } = this.props;
    const { getFieldsValue, getFieldDecorator, setFieldsValue } = form;
    const that = this;

    // 上传封面图片props
    const coverUploadProps = {
      accept: "image/png, image/jpeg, image/jpg",
      action: `${api.url}/web/v3/news/file/upload`,
      withCredentials: true,
      name: "file",
      listType: "picture-card",
      data: { newsType: 2 },
      beforeUpload(file) {
        return new Promise((resolve, reject) => {
          const type = ["image/jpeg", "image/png", "image/jpg"];
          const isJPG = type.indexOf(file.type) !== -1;
          if (!isJPG) {
            message.error("只能上传jpg/png/jpeg格式图片!");
          }
          const isLt5M = file.size / 1024 / 1024 < 5;
          if (!isLt5M) {
            message.error("图片不能大小超过5MB!");
          }
          if (!isJPG || !isLt5M) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return reject(false);
          }
          return resolve(true);
        });
      },
      onChange(info) {
        const { status } = info.file;
        if (status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (status === "done") {
          const { response, name, msg } = info.file;
          if (response.code === 200 || response.code === 0) {
            const ele = JSON.parse(
              JSON.stringify(uploadFileVOList[currentIndex])
            );
            setFieldsValue({
              [`coverPicFileId-${currentIndex}`]: response.data.fileId
            });
            ele.coverPicFileId = response.data.fileId;
            ele.coverPicFileUrl = response.data.fileUrl;
            const arr = JSON.parse(JSON.stringify(uploadFileVOList));
            arr[currentIndex] = ele;
            that.setState({ uploadFileVOList: arr });
            message.success(`${name} 上传成功.`);
          } else {
            message.error(`${info.file.name} 上传失败.${msg}`);
          }
        } else if (status === "error") {
          message.error(`${info.file.name} 上传失败.`);
        }
      }
    };

    // FormTitle组件属性
    const titleProps = {
      form,
      value: title,
      label: "素材标题",
      keyName: `title-${currentIndex}`,
      maxLength: 100,
      isRequired: true,
      suffix: `${(getFieldsValue().title && getFieldsValue().title.length) ||
        (title && title.length) ||
        0}/100`,
      onChange: e => this.onChange(e.target.value, currentIndex, "title")
    };

    // FileUpload组件属性
    const fileUploadProps = {
      className: "file-upload",
      form,
      groupId,
      keyName: `fileId-${currentIndex}`,
      label: "素材文件",
      maxNumber: 1,
      maxSize: 1024,
      isRequired: true,
      uploadInfo:
        "最多可上传1个附件，音视频格式支持：mp4/flv/mov/mp3，大小1G以内",
      handleFileGroupId: fileId =>
        this.onChange(fileId, currentIndex, "groupId")
    };

    return (
      <div className="video-info-wrap" key={`${lxVideoId}${currentIndex}`}>
        {/* 左边_素材列表 */}
        <div className="video-list-box">
          {uploadFileVOList.map((item, index) => {
            return this.renderCommon(item, index);
          })}
          {uploadFileVOList.length < 8 && !this.id && this.renderAdd()}
        </div>
        {/* 右边_表单内容 */}
        <div className="video-info">
          <FormTitle {...titleProps} />
          {this.id && uploadFileVOList[currentIndex] && uploadFileVOList[currentIndex].lxVideoName ? (
            <Item label="素材文件：">
              <div className="row-wrap">
                <div className="video-title">
                  <img src="https://s.xiaoyuanhao.com/microsite/image/video_icon_img_n.svg" alt="" />
                  <div style={{display:"inline-block",lineHeight:"1.3"}}>
                    <div>{uploadFileVOList[currentIndex].lxVideoName}</div>
                    <div className="size">{(uploadFileVOList[currentIndex].lxVideoSize / 1024 / 1024).toFixed(2)}M</div>
                  </div>
                </div>
                <div className="del" onClick={this.delVideo}>删除</div>
              </div>

              {/* <div className="video-title">
                <img
                  src="https://s.xiaoyuanhao.com/microsite/image/video_icon_img_n.svg"
                  alt=""
                />
                <span>{uploadFileVOList[currentIndex].lxVideoName}</span>
                <span>{(uploadFileVOList[currentIndex].lxVideoSize / 1024 / 1024).toFixed(2)}M</span>
              </div> */}
            </Item>
          ) : (
            <FileUpload {...fileUploadProps} />
          )}
          <Item label="素材介绍：" className="content">
            {getFieldDecorator(`content`, {
              initialValue: "",
              rules: [{ required: false, message: "请填写素材介绍" }]
            })(
              <WxEditor
                showTemplate={false}
                onChange={value =>
                  this.onChange(value, currentIndex, "content")
                }
              />
            )}
          </Item>
          <Item label="封面：" className="necessary">
            {getFieldDecorator(`coverPicFileId-${currentIndex}`)(
              <>
                <Upload {...coverUploadProps}>
                  {coverPicFileUrl ? (
                    <div className="upload-button">
                      <div
                        className="cover"
                        style={{ backgroundImage: `url(${coverPicFileUrl})` }}
                      />
                      <div className="ant-upload-text-cover">上传图片</div>
                    </div>
                  ) : (
                    <div>
                      <Icon type="plus" />
                      <div className="ant-upload-text">上传封面</div>
                    </div>
                  )}
                </Upload>
                <div className="tips">
                  说明：建议尺寸：230px*154px，封面图最大可上传5M
                </div>
              </>
            )}
          </Item>
          <Item label="完成条件：" className="necessary">
            累计播放时长达到视频总时长的
            <InputNumber
              precision={0}
              step={1}
              min={1}
              max={100}
              defaultValue={completePercent}
              onChange={value =>
                this.onChange(value, currentIndex, "completePercent")
              }
            />
            %
          </Item>
          {/* <Item label="关联标签：">
            {getFieldDecorator(`labelList-${currentIndex}`, {
              initialValue: labelList,
              valuePropName: "checked",
              trigger: "handleOk",
              getValueFromEvent: ({ checkedValue = [] } = {}) => {
                return checkedValue;
              },
              rules: [
                {
                  required: false,
                  message: "请选择标签"
                }
              ]
            })(
              <SelectTagModal
                checkedValue={labelList}
                groupData={groupData}
                handleOk={data => this.handleSaveLabelOk(data, currentIndex)}
              />
            )}
            <div className="select-label-tips">说明: 最多可关联10个标签</div>
          </Item> */}
        </div>
        {/* <div
          style={{
            width: 34,
            height: 34,
            borderRadius: '50%',
            backgroundColor: 'rgba(247, 247, 250, 1)',
            textAlign: 'center',
            lineHeight: '34px',
            position: 'relative',
            top: '100px',
            cursor: 'pointer',
          }}
        >
          <img
            src="https://s.xiaoyuanhao.com/iamge/micro/delete.svg"
            alt=""
            onClick={() => this.deleteVideo(index)}
          />
        </div> */}
      </div>
    );
  };

  render() {
    const {
      spinning,
      activeKey,
      channelList = [],
      uploadFileVOList = [],
      data
    } = this.state;
    const { channelId } = data;
    const { form } = this.props;
    const formItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 }
    };

    const customerFormItemLayout = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 }
    };

    const channelIdProps = {
      form,
      value: channelId,
      label: "素材栏目",
      keyName: "channelId",
      isRequired: true,
      optionsData: channelList
    };

    return (
      <Container
        breStates={!0}
        version={2}
        defaultPadding
        footerParams={this.renderFooter()}
      >
        <Spin spinning={spinning}>
          <div className={styles.root}>
            <FormCreate customerFormItemLayout={customerFormItemLayout}>
              <Tabs activeKey={activeKey} onChange={this.changeTab}>
                <TabPane
                  tab={this.renderTabTitle(activeKey, "素材上传", "1")}
                  key="1"
                >
                  {this.renderVideoItem()}

                  {/* {this.id ? null : (
                    <Item label="素材内容" {...formItemLayout}>
                      <div className="ant-upload-drag-icon" onClick={this.addVideo}>
                        +<div className="ant-upload-text">新增素材，最多可上传10个素材</div>
                      </div>
                    </Item>
                  )} */}
                </TabPane>
                <TabPane
                  tab={this.renderTabTitle(activeKey, "属性设置", "2")}
                  key="2"
                >
                  <FormCascader {...channelIdProps} />
                </TabPane>
              </Tabs>
            </FormCreate>
          </div>
        </Spin>
      </Container>
    );
  }
}
export default CreateVideo;
